// DatePicker.tsx
import React, { useState, useRef, useEffect } from "react"
import { DayPicker, SelectSingleEventHandler } from "react-day-picker"
import { ptBR } from "date-fns/locale"
import "react-day-picker/dist/style.css"

import { DatePickerContainer, InputStyled } from "./styles"

interface DatePickerProps {
  selected?: Date | undefined
  onSelect: (date: Date | undefined) => void
}

const DatePickerInput: React.FC<DatePickerProps> = ({ selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false)
  const datePickerRef = useRef<HTMLDivElement>(null)

  const handleSelect: SelectSingleEventHandler = (day) => {
    onSelect(day || undefined)
    setIsOpen(false)
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={datePickerRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      <InputStyled
        id="date-picker"
        readOnly
        value={selected ? selected.toLocaleDateString() : ""}
        placeholder="Selecione uma data"
        onClick={() => setIsOpen((o) => !o)}
      />
      {isOpen && (
        <DatePickerContainer>
          <DayPicker
            mode="single"
            selected={selected}
            onSelect={handleSelect}
            locale={ptBR}
            defaultMonth={selected}
            initialFocus
          />
        </DatePickerContainer>
      )}
    </div>
  )
}

export default DatePickerInput
